export const MIN_NON_INDIAN_PHONE = 9;
export const MAX_NON_INDIAN_PHONE = 15;
export const INDIAN_PHONE_LENGTH = 10;

export const INDIA_COUNTRY_CODE = '+91';
